import styled from 'styled-components';

export const SliderContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const SliderHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`;

export const SliderLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.primaryTextColor};
  margin-bottom: 6px;
`;

export const SliderValue = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.primaryTextColor};
  margin-left: auto;
`;

export const StyledRangeInput = styled.input<{ $size: number; $fillPercentage: number }>`
  appearance: none;
  width: 100%;
  height: ${({ $size }) => `${$size}px`};
  border-radius: 10px;
  outline: none;
  background: ${({ theme }) => theme.slider.track.background};
  background-image: linear-gradient(
    ${({ theme }) => theme.slider.thumb.background}, 
    ${({ theme }) => theme.slider.thumb.background}
  );
  background-size: ${({ $fillPercentage }) => `${$fillPercentage}% 100%`};
  background-repeat: no-repeat;

  &::-webkit-slider-thumb {
    appearance: none;
    width: ${({ $size }) => `${$size * 2}px`};
    height: ${({ $size }) => `${$size * 2}px`};
    border-radius: 50%;
    background: ${({ theme }) => theme.slider.thumb.fill};
    cursor: pointer;
    border: 2px solid ${({ theme }) => theme.slider.thumb.border};
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  &::-moz-range-thumb {
    width: ${({ $size }) => `${$size * 2}px`};
    height: ${({ $size }) => `${$size * 2}px`};
    border-radius: 50%;
    background: ${({ theme }) => theme.slider.thumb.background};
    cursor: pointer;
    border: 2px solid ${({ theme }) => theme.slider.thumb.border};
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
